import { render } from "./BannerChongya.vue?vue&type=template&id=399dc560"
import script from "./BannerChongya.vue?vue&type=script&lang=js"
export * from "./BannerChongya.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__